import React, { useState, useRef, useEffect } from 'react';
//import { useAuth0 } from '@auth0/auth0-react';
import SocialLogin from './socialLogin/SocialLogin';
import { IoMdCloseCircle } from "react-icons/io";
import { useContext } from 'react';
import { AuthContext } from '../../../context/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const Login = () => {

    const { setUsuario } = useContext(AuthContext);
     const navigate = useNavigate();

 // const { loginWithRedirect } = useAuth0();
  const [showForm, setShowForm] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [traerModal, setTraerModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [traerModalOlvidePassword, setTraerModalOlvidePassword] = useState(false)
  const emailInputRef = useRef(null);



    useEffect(() => {
  if (traerModal && emailInputRef.current) {
    emailInputRef.current.focus();
  }
}, [traerModal]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setErrorMsg('Por favor completá los campos');
      return;
    }
    
    try {
        const data = {
            peticion: 14,
            param:{
            proveedor: 'mail',
            id_proveedor: email,
            correo: email,
            token_acceso: password,
            esLogin: 1
        }
        }
          setLoading(true) 
        const response = await fetch('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosUsuario.php', {
            method: 'POST',
            headers: new Headers(), // no incluimos Content-Type para evitar preflight
            body: JSON.stringify(data),
    })
    const result = await response.json();
    
    if (result) {
        if (result.data.id_proveedor!==null && result.data.nombre_completo!=="Usuario No Encontrado" && result.data.token_acceso!==""){
        setUsuario(result.data)
        localStorage.setItem('usuario', JSON.stringify(result.data));
        toast.success(`Hola bienvenido ${result.data.nombre_completo}👋`, {
            duration: 4000,
            position: "top-center",
          });
        navigate('/'); // o donde quieras redirigirlo
      }   
      else {
        toast.error("Error al loguearse.", {
            duration: 4000,
            position: "top-center",
          });
          return
      } 
}
}
    catch(error) {
        console.error('Error en la Request',error)

    }
    finally {
        setLoading(false)
    }
  };

  return (
    <>
    <div className="min-h-screen flex items-center bg-amber-500 justify-center pt-20">
     

    <div className="relative p-4 w-full  h-full md:h-auto items-center justify-center flex ">

    <div className="relative bg-white md:p-20 p-5 rounded-lg shadow  ">
    <div className="p-5">
        <h3 className="text-2xl mb-0.5 font-medium"></h3>
        <p className="mb-4 text-sm font-normal text-gray-800"></p>

        <div className="text-center">
            <p className="mb-3 text-2xl font-semibold leading-5 text-slate-900">
               Iniciar Sesion
            </p>
            <p className="mt-2 text-sm leading-4 text-slate-600">
                Puedes iniciar sesion, con las siguientes redes sociales:
            </p>
        </div>

        <div className="mt-7 flex flex-col gap-2">

       
            <SocialLogin/>



        </div>

        <div className="flex w-full items-center gap-2 py-6 text-sm text-slate-600">
            <div className="h-px w-full bg-slate-200"></div>
            O
            <div className="h-px w-full bg-slate-200">    
            </div>
           
        </div>
        <div className=' flex flex-col gap-2'>
            <button onClick={() => setTraerModal(true) }><p className='text-sm '> Iniciar sesion con Mail & Contraseña</p></button>
            </div>
        { traerModal &&
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded-lg sm:max-w-sm  m-10 md:m-0 w-full md:max-w-2xl text-center shadow-lg">
        <form className="w-full" onSubmit={handleSubmit}>
            <div className=' flex justify-end'>
            <button type="button" onClick={()=> setTraerModal(false)}><IoMdCloseCircle size={24} /></button>
            
            </div>
        <h2 className="text-xl font-bebas mb-4">Iniciar Sesion:</h2>
            <label className="sr-only">Mail</label>
            <input name="email" type="email" required=""
                className="block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm outline-none placeholder:text-gray-400 focus:ring-2 focus:ring-black focus:ring-offset-1"
                placeholder="Mail" value={email} onChange={(e)=> setEmail(e.target.value)} ref={emailInputRef}/>
            <label  className="sr-only">Contraseña</label>
            <input name="password" type="password"  required=""
                className="mt-2 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm outline-none placeholder:text-gray-400 focus:ring-2 focus:ring-black focus:ring-offset-1"
                placeholder="Contraseña" value={password} onChange={(e)=> setPassword(e.target.value)}/>
            
            <button type="submit"
          
                className="mt-5 inline-flex w-full items-center justify-center rounded-lg bg-black p-2 py-3 text-sm font-medium text-white outline-none focus:ring-2 focus:ring-black focus:ring-offset-1 disabled:bg-gray-400">
                Continuar
            </button>
            <p className="mb-3 mt-2 text-sm text-gray-500">
                <Link onClick={() => setTraerModalOlvidePassword(true)} className="text-gray-800  text-sm hover:text-gray-600">Me olvide la contraseña</Link>
            </p>
        </form>

        <div className="mt-6 text-center text-sm text-slate-600">
        No tienes cuenta? 
            <a href="/auth/register" className="font-medium text-gray-700"> Registrar</a>
        </div>
       
        </div>
        </div>}

         {traerModalOlvidePassword && <>
         
         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-10 rounded-lg sm:max-w-sm  m-10 md:m-0 w-full md:max-w-xl text-center shadow-lg">
            <div className='flex  justify-end '>
              <button onClick={()=> setTraerModalOlvidePassword(false)} ><IoMdCloseCircle size={24} /></button>
              </div>
            <div className='grid gap-5 flex justify-center items-center'>
            <h2 className='text-md font-bebas p-5'>Por favor comuniquese con nuestro WhatsApp. Muchas Gracias</h2>
            <span className='text-sm'> Para que podamos ayudarlo, envienos un WhatsApp y le responderemos a la brevedad. </span>
            <Link className='bg-zinc-600 hover:bg-zinc-900 text-white hover:text-white px-4 py-2 rounded text-sm text-center font-bebas' to="https://wa.me/5491155822610?text=Hola!+olvide+mi+contraseña+en+la+web+Estancia+La+Margarita+" target="_blank">Enviar WhatsApp</Link>
            
            </div>
            </div>
        </div>
            
        </>}
    </div>
</div>
</div>

</div>

    </>
  );
};

export default Login;